import FastMarquee from "react-fast-marquee";

const ITEMS = ["NCAA Division I", "NCAA Division II", "NCAA Division III", "NAIA", "NJCAA", "U Sports"];

export default function Marquee() {
  return (
    <section className="py-16 md:py-24 border-y border-white/10 overflow-hidden" data-testid="pathway-marquee">
      <FastMarquee speed={25} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-playfair italic text-4xl md:text-6xl text-white/25 px-8 md:px-16 whitespace-nowrap">
              {item}
            </span>
            <span className="text-volt text-2xl md:text-4xl" aria-hidden="true">—</span>
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
